'use client';
import useGetReviews from '@/features/api/use-get-reviews';
import { onest, inter } from '@/styles/fonts';

const ReviewCards = () => {
  const { data: reviews, isLoading } = useGetReviews();

  return (
    <>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          {reviews?.map((review) => (
            <article
              key={review._id}
              className="flex flex-col place-items-center gap-4 rounded-[16px] border border-rm-neutral-200 px-[22px] py-[34px] shadow-[0px_1px_3px_0px_rgba(25,33,61,0.25)] 2xl:px-[30px] 2xl:py-10"
            >
              <blockquote>
                <p
                  className={`${onest.className} text-[1rem] font-normal text-rm-secondary-100 lg:text-lg lg:leading-tight 2xl:text-[1.25rem]`}
                >
                  {review.review}
                </p>
              </blockquote>
              <footer className="flex w-full items-center gap-x-5 lg:h-[44px]">
                <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-rm-neutral-200 text-lg font-semibold text-rm-primary-100 shadow-[0px_1px_3px_0px_rgba(25,33,61,0.10)]">
                  {review?.firstName.charAt(0)}
                </div>
                <div className={onest.className}>
                  <p
                    className={`${inter.className} text-lg font-semibold text-rm-neutral-700 2xl:text-[1.5rem]`}
                  >
                    {review.firstName} {review.lastName.charAt(0)}.
                  </p>
                  <p className="text-[1rem] text-muted-foreground">
                    {review.location}
                  </p>
                </div>
              </footer>
            </article>
          ))}
        </>
      )}
    </>
  );
};

export default ReviewCards;
